import ContentStepContainer from './ContentStepContainer';
import RecipientStepContainer from './RecipientStepContainer';
import CoachStepContainer from './CoachStepContainer';
import ObjectiveStep from './ObjectiveStep';
import MeetingTypeStep from './MeetingTypeStep';
import ReviewPreparationStep from './ReviewPreparationStep';
import SchedulingStep from './SchedulingStep';
import DurationStep from './DurationStep';
import {List} from 'immutable';
import './CoachingStep.styl';
import ReviewTypeStepContainer from 'components/coaching/wizard/steps/ReviewTypeStepContainer';

export default List([
  RecipientStepContainer,
  CoachStepContainer,
  DurationStep,
  SchedulingStep,
  MeetingTypeStep,
  ContentStepContainer,
  ObjectiveStep,
  ReviewTypeStepContainer,
  ReviewPreparationStep,
]);
